import React, { useState, forwardRef } from 'react';
import { Icon } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MDInput from "dashboard/components/MDInput";
import MDButton from "dashboard/components/MDButton";
import MDTypography from "dashboard/components/MDTypography";

const DistributorUpdate = forwardRef(({ productName, initialState, handleChanges, id, isLoading }, ref) =>{

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialState || {
    quantity: '',
    price: '',
    sold: '',
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: Number(value),
    });
  };

  const handleSubmit = () => {
    // Handle the submission logic here
    handleChanges({id,update : formData})
    handleClose();
  };

  return (
    <div>
      <MDButton ref={ref}  size="medium" onClick={handleClickOpen} disableRipple={false}  sx={{minHeight:35, minWidth:35, p:.5}}  variant="gradient"  color="light"><Icon size="medium">edit</Icon></MDButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Modifier <MDTypography color="primary" variant="span"> {productName}</MDTypography></DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter the required information.
          </DialogContentText>
          <MDInput
            autoFocus
            margin="dense"
            name="quantity"
            label="Quantité"
            type="number"
            fullWidth
            variant="outlined"
            value={formData.quantity}
            onChange={handleInputChange}
          />
          <MDInput
            margin="dense"
            name="price"
            label="Prix"
            type="number"
            fullWidth
            variant="outlined"
            value={formData.price}
            onChange={handleInputChange}
          />
          <MDInput
            margin="dense"
            name="sold"
            label="Vendu"
            type="number"
            fullWidth
            variant="outlined"
            value={formData.sold}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose} color="secondary">Cancel</MDButton>
          <MDButton onClick={handleSubmit} color="info" disabled={isLoading} >valider</MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default  DistributorUpdate;
